export type ImportJobState =
  | 'completed'
  | 'failed'
  | 'active'
  | 'waiting'
  | 'delayed'
  | 'not_found'
  | string;

export interface ImportJobStatus {
  state: ImportJobState;
  result: unknown;
  /** 0-100, only meaningful while the job reports incremental progress (e.g. paginated syncs). */
  progress: number;
}

export const TERMINAL_IMPORT_JOB_STATES: ImportJobState[] = ['completed', 'failed', 'not_found'];

/** A sync job tracked client-side, regardless of which connector/dialog started it. */
export interface ImportJob {
  id: string;
  connector: string;
  label: string;
  startedAt: number;
}

/** A job the backend reports as still active/waiting/delayed, used to recover state after a reload and to poll progress in bulk. */
export interface ActiveImportJob {
  jobId: string;
  connectionId: string;
  target: string;
  connector: string;
  startedAt: number;
  state: ImportJobState;
  /** 0-100, only meaningful while the job reports incremental progress (e.g. paginated syncs). */
  progress: number;
  result: unknown;
}

/** One job enqueued as part of a full sync, identified by which sync target it covers (e.g. 'inventory', 'orders'). */
export interface FullSyncJob {
  jobId: string;
  target: string;
}
